import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AnimalType, simplify} from "src/app/infrastructure/moovement-api/models/asset";

@Component({
  selector: 'app-animal-svg',
  imports: [],
  templateUrl: './animal-svg.component.html',
  styleUrl: './animal-svg.component.css'
})
export class AnimalSvgComponent implements OnChanges {
  @Input() width: string = '50'
  @Input() height: string = '50'
  @Input() animalType?: AnimalType | string | undefined;
  @Input() type?: string = simplify(this.animalType)
  
  ngOnChanges(changes: SimpleChanges): void {
    const newValue = changes['animalType']?.currentValue as AnimalType;
    if (newValue != undefined) {
      this.type = simplify(newValue)
    }
  }
}
